import { useCallback, useEffect, useRef } from "react";

type Props = {
  hasMore: boolean;
  onLoadMore: () => void;
};

export function InfiniteScroll({ hasMore, onLoadMore }: Props) {
  const rootMargin = "200px";
  const sentinelRef = useRef<HTMLDivElement>(null);

  const loadMore = useCallback(() => {
    if (hasMore) onLoadMore();
  }, [hasMore, onLoadMore]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) loadMore();
      },
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [loadMore, rootMargin]);

  return <div ref={sentinelRef} style={{ height: 1 }} />;
}
